// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__yIdyP","disabled":"FileBtn_disabled__248nL","warn":"FileBtn_warn__1thdv","fade":"FileBtn_fade__10sRZ"};